import { useLayoutEffect, useEffect } from 'react';
import EventEmitter from 'eventemitter3';

const eventEmitter = new EventEmitter();
function addEventListener(namespace, eventType, fn) {
  eventEmitter.addListener(`${namespace}.${eventType}`, fn);
}
function removeEventListener(namespace, eventType, fn) {
  eventEmitter.removeListener(`${namespace}.${eventType}`, fn);
}
function emitEvent(event) {
  eventEmitter.emit(`${event.namespace}.${event.type}`, event);
}

function useEvent(namespace, type, fn, deps = []) {
  useLayoutEffect(() => {
    addEventListener(namespace, type, fn);
    return () => {
      removeEventListener(namespace, type, fn);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [namespace, type, ...deps]);
}

function createEvent(namespace, type) {
  const emit = payload => {
    emitEvent({
      namespace,
      type,
      payload
    });
  };
  return {
    emit: payload => {
      emit(payload);
    },
    useEvent: (fn, deps = []) => {
      useEvent(namespace, type, fn, deps);
    },
    on: fn => {
      addEventListener(namespace, type, fn);
    },
    off: fn => {
      removeEventListener(namespace, type, fn);
    },
    Component: ({
      payload,
      children
    }) => {
      useEffect(() => {
        emit(payload);
      }, [payload]);
      return children ?? null;
    }
  };
}

export { addEventListener, createEvent, emitEvent, removeEventListener };
//# sourceMappingURL=index.js.map
